/**
 * @generated SignedSource<<29a1052474b142f9b171634410193729>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerAllMenuQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"headerAllMenuColumnistsQuery" | "headerAllMenuHighlightsQuery" | "headerAllMenuSectionAppConfigQuery" | "headerAllMenuTopicsQuery">;
  readonly " $fragmentType": "headerAllMenuQuery";
};
export type headerAllMenuQuery$key = {
  readonly " $data"?: headerAllMenuQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerAllMenuQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerAllMenuQuery",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerAllMenuColumnistsQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerAllMenuHighlightsQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerAllMenuSectionAppConfigQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerAllMenuTopicsQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "56849957a8bdd104da3c658e045ca94e";

export default node;
